<section id="main-section" class="pd-b40" (click)="removePhoneSearch($event)">
    <div class="w-100">
        <article class="profile">
            <div class="d-flex profile__banner">
                <div class="profile__top">
                    <div class="profile-cont__pic">
                        <div class="profile--pic">
                            <img [src]="imgFile ? imgFile : '/assets/images/upgradRed/user-profile-placeholder.png'" alt="" />
                        </div>
                        <div class="leaderboard--name text-center" *ngIf="isleaderboard">
                            <span [ngClass]="{
                                'achiever':(storeData.rankColour == 'Yellow'),
                                'novice':(storeData.rankColour == 'Red')
                            }">{{storeData['rankStatus']}}</span>
                        </div>
                        <div class="profile-cont__pic--hover">
                            <div class="upload__profile cursor-pointer">
                                <input type="file" (change)="testNewUpload($event)" (click)="clearEvent($event)"
                                    accept=".jpg,.jpeg,.png" />
                            </div>
                            <a *ngIf="imgFile" (click)="deleteProfilePic($event)" class="icon-bin cursor-pointer"></a>


                        </div>

                    </div>
                    <div class="profile__top--cont">
                        <h3 class="dark-color">
                            {{userPrevObj.firstName}}
                            {{userPrevObj.lastName}}
                        </h3>
                        <div class="d-flex profile__header">
                            <div class="d-flex profile__header--links">
                                <div class="profile__header--update">
                                    Joined {{user?.created | date : "MMM dd, yyyy"}}
                                </div>
                                <div class="profile__header--tooltip">
                                    <span>Partner Member</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Personal Information -->
            <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
                <div class="profile-cont d-flex" *ngIf="!reset_password_enabled">

                    <div class="profile-cont__form" *ngIf="isProfileDisable">

                        <div class="profile-cont__form--outer">
                            <div class="profile-cont__form--group">
                                <input type="text" formControlName="firstName" required="required"
                                    placeholder="First name" pattern='[A-Za-z]+$' maxlength="20" />
                                <div *ngIf="profileForm.controls['firstName'].invalid && (profileForm.controls['firstName'].dirty || profileForm.controls['firstName'].touched)"
                                    class="">
                                    <div *ngIf="profileForm.controls['firstName'].errors.required">
                                        <span class="label-error">First Name is required</span>
                                    </div>
                                </div>
                                <div *ngIf="profileForm.controls['firstName'].invalid" class="">
                                    <div *ngIf="profileForm.controls['firstName'].errors.pattern">
                                        <span class="label-error">Only allowed letter and few symbols like . - and '</span>
                                    </div>
                                </div>
                            </div>
                            <div class="profile-cont__form--group">
                                <input type="text" formControlName="lastName" placeholder="Last name" maxlength="20" />
                                <div *ngIf="profileForm.controls['lastName'].invalid" class="">
                                    <div *ngIf="profileForm.controls['lastName'].errors.pattern">
                                        <span class="label-error">Only allowed letter and few symbols like . - and '</span>
                                    </div>
                                </div>
                            </div>

                            <div class="profile-cont__form--group">
                                <div class="phn--outer">
                                    <div class="phn--ext">
                                        <div class="dropdown">
                                            <button type="button" [title]="[defaultCountryCode]" class="dropbtn"
                                                (click)="showDropdown()"
                                                [ngClass]="{'active__arrow': showDropDown }">{{defaultCountryCode}}</button>
                                            <div id="myDropdown" class="dropdown-content"
                                                [ngClass]="{'show': showDropDown }">
                                                <!--  -->
                                                <input type="text" placeholder="Search Country" id="myInput"
                                                    (keyup)="filterFunction($event)" autocomplete="off">
                                                <span class="dropdown__icon icon-search"></span>
                                                <ul>
                                                    <li class="cursor-pointer" *ngFor="let c of country"
                                                        attr.data-code="{{c.dial_code}} ({{c.code}})"
                                                        (click)="countrySelected(c)">
                                                        ({{c.dial_code}}) {{c.name}}</li>
                                                </ul>
                                            </div>
                                            <i class="bar"></i>
                                        </div>
                                    </div>
                                    <div class="phn--number">
                                        <input type="phone" autocomplete="nope" formControlName="phone"
                                            (keypress)="keyPress($event)" maxlength=10
                                            placeholder="Enter Mobile Number" />
                                    </div>
                                </div>
                            </div>
                            <div class="profile-cont__form--group">
                                <input type="text" formControlName="email" readonly class="disabled--email"
                                    placeholder="Email" />
                            </div>
                            <div class="profile-cont__form--group profile-cont__form--ext" *ngIf="!user?.isSSO">
                                <div class="phn--outer">
                                    <div class="phn--ext-new">
                                        <div class="dropdown">
                                            <button type="button" [title]="[defaultTimezone]" class="dropbtnTimezone"
                                                (click)="showTimezone()"
                                                [ngClass]="{'active__arrow': showTimeZone }">{{defaultTimezone}}</button>
                                            <div id="myDropdownTimezone" class="dropdown-content"
                                                [ngClass]="{'show': showTimeZone }">
                                                <!--  -->
                                                <input type="text" placeholder="Search Country" id="myInputTimezone"
                                                    (keyup)="filterTimezone($event)" autocomplete="off">
                                                <!-- <span class="dropdown__icon icon-search"></span> -->
                                                <ul>
                                                    <li class="cursor-pointer {{t.label.trim() === defaultTimezone.trim()? 'active':''}}" *ngFor="let t of timezoneDrop"
                                                        attr.data-code="{{t.value}}" (click)="timezoneSelected(t)">
                                                        {{t.label}}</li>
                                                </ul>
                                            </div>
                                            <i class="bar"></i>
                                        </div>
                                    </div>
                                </div>

                            </div>
                           
                            <div class="profile-cont__save">
                                <button class="light-color link-no-underline red--button "
                                    [disabled]="!profileForm.valid">
                                    Save
                                </button>
                            </div>
                            <div class="profile-cont__form--group profile-cont__form--ext" *ngIf="!user?.isSSO">
                                <div class="reset--pw"><a (click)="hideAndShowResetPassword('reset')">Change Your
                                        Password</a></div>
                            </div>

                        </div>

                    </div>
                </div>
            </form>
            <!-- Reset Password -->
            <form [formGroup]="resetPasswordForm">
                <div class="profile-cont reset-cont light-bg d-flex" *ngIf="reset_password_enabled">
                    <h3 class="dark-color mob-none">
                        Reset Password
                    </h3>
                    <div class="profile-cont__form reset_form">
                        <h3 class="dark-color">
                            Reset Password
                        </h3>
                        <div class="profile-cont__form--outer">
                            <div class="profile-cont__form--group">
                                <input type="password" required="required" placeholder="Enter Old Password"
                                    [ngClass]="{ 'is-invalid': submitted && f.oldPassword.errors }" minlength="8"
                                    formControlName="oldPassword" id="password-field2" />
                                <span class="password--icon icon-eye-blocked cursor-pointer" id="password--status2"
                                    onClick="viewOldPassword()"></span>
                            </div>
                        </div>
                        <div class="profile-cont__form--outer--reset-password">
                            <div class="profile-cont__form--group">
                                <input type="password" required="required" placeholder="Enter New Password"
                                    [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }" minlength="8"
                                    formControlName="newPassword" id="password-field1" />
                                <span class="password--icon icon-eye-blocked cursor-pointer" id="password--status1"
                                    onClick="viewResetPassword()"></span>
                                <div *ngIf="f.newPassword.errors && (f.newPassword.dirty || f.newPassword.touched)"
                                    class="invalid-feedback">
                                    <div class="label-error" *ngIf="f.newPassword.errors.required">Password is required
                                    </div>
                                    <div class="label-error" *ngIf="f.newPassword.errors.minlength">Password must be at
                                        least 8 characters
                                    </div>
                                    <div *ngIf="!f.newPassword.errors.minlength && !f.newPassword.errors.required">
                                        <div class="label-error" *ngIf="f.newPassword.errors.strong">Password must
                                            contain upper case,
                                            lower case, number and special character
                                        </div>
                                    </div>
                                    <div
                                        *ngIf="!f.newPassword.errors.minlength && !f.newPassword.errors.required && !f.newPassword.errors.strong">
                                        <div class="label-error" *ngIf="f.newPassword.errors.same">New password cannot
                                            be same as old password
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="profile-cont__form--group">
                                <span id="password--status" class="password--icon icon-eye-blocked cursor-pointer"
                                    onClick="viewPassword()"></span>

                                <input type="password" required="required" placeholder="Confirm Password"
                                    [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }"
                                    formControlName="confirmPassword" id="password-field" />
                                <div *ngIf="f.confirmPassword.errors && (f.confirmPassword.dirty || f.confirmPassword.touched)"
                                    class="invalid-feedback">
                                    <div class="label-error" *ngIf="f.confirmPassword.errors.required">Confirm Password
                                        is required</div>
                                    <div class="label-error" *ngIf="f.confirmPassword.errors.mustMatch">Both passwords
                                        do not match</div>
                                </div>
                            </div>
                            <div class="profile-cont__save--reset-password d-flex align-items-center">
                                <!-- <div class="reset--pw"><a (click)="hideAndShowResetPassword('cancel')">Cancel</a></div> -->
                                <button class="light-color link-no-underline red--button "
                                    (click)="hideAndShowResetPassword('cancel')">
                                    Cancel
                                </button>
                                <button class="light-color link-no-underline red--button "
                                    [disabled]="mustMatchPassword() || !submitted " (click)="resetPassword()">
                                    Save
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </form>

            <footer class="profile__footer">
                If you wish to delete your account or report an issue of a data breach, please reach out to <a
                    href="mailto:dpo@upgrad-enterprise.com">dpo@upgrad-enterprise.com</a>
            </footer>
            <!-- <div class="green-banner">
                Your Name & Password has updated. <span class="icon-Icon-awesome-check-circle"></span>
            </div> -->
        </article>
    </div>
</section>

<div *ngIf="imageUpload" class="popup-main popup--overlay" style="display: flex;">
    <div class="popup" style="max-width: 75%;max-height: 80%;">

        <button class="popup--close"><span class="icon-cross" (click)="hidePopup()"></span></button>

        <div class="popup__content">
            <image-cropper style="max-height: 300px;" (imageCropped)="imageCropped($event)"
                [maintainAspectRatio]="false" [aspectRatio]="4 / 3" [resizeToWidth]="1024"
                [imageChangedEvent]="imageUploadEvent" [onlyScaleDown]="true"></image-cropper>
            <div class="profile-cont__save">
                <button (click)="UploadFinal($event)" class="light-color link-no-underline blue--button ">
                    Save
                </button>
            </div>
        </div>
    </div>
</div>